import Dropdown from '../../atoms/Dropdown.js';
import { DataComputed, DataModel } from '@studiometa/ui';
import { importOnInteraction } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} ComponentProps
 */

/**
 * Component component.
 * @augments {Base<ComponentProps>}
 */
export default class Categories extends Dropdown {
  listing = 'destinations-list';

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Categories',
    refs: [
      'containerMap',
      'containerTab',
      'dropdown',
      'btn',
      'checkboxs[]',
      'close[]',
      'placeholder',
      'loader',
    ],
    components: {
      DataComputed,
      DataModel,
      Switch: (app) =>
        importOnInteraction(() => import('../../atoms/Switch.js'), app.$refs.btn, 'click'),
    },
  };

  /**
   * Mount component
   */
  mounted() {
    this.defaultPlaceholder = this.$refs.placeholder.textContent.trim();
    this.changePin();
  }

  /**
   * Switching tabs
   * @param {object} props Props
   * @param {Array} props.args params
   * @returns {void}
   */
  onSwitchTabChange({ args }) {
    this.$refs.loader.classList.remove('opacity-0', 'pointer-events-none');

    fetch('/wp/wp-admin/admin-ajax.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `action=render_template&template=${args}&security=custom_nonce`,
    })
      .then((response) => response.json())
      .then((response) => {
        this.$refs.containerTab.innerHTML = response.data;
        this.$parent.$update();

        this.$refs.loader.classList.add('opacity-0', 'pointer-events-none');

        this.listing = args[0];

        setTimeout(() => {
          this.changePin();
        }, 100);
      });
  }

  /**
   * Show/hide pin when click on checkboxs
   */
  onCheckboxsClick() {
    this.changePin();
  }

  /**
   * ChangePin
   */
  changePin() {
    this.$refs.placeholder.textContent = '';
    let placeholderString = '';

    this.$refs.checkboxs.forEach((checkbox) => {
      if (checkbox.checked) {
        this.generatePin(checkbox);

        placeholderString +=
          placeholderString === '' ? checkbox.dataset.name : `, ${checkbox.dataset.name}`;
      } else {
        this.removePin(checkbox);
      }
    });

    if (placeholderString === '') {
      placeholderString = this.defaultPlaceholder;
    }

    this.$refs.placeholder.innerHTML = placeholderString;
  }

  /**
   * Generate pin on map
   * @param  {object} element clicked element
   * @returns {void}
   */
  generatePin(element) {
    if (this.listing === 'themes-list') return;

    const pin = document.querySelector(`#pin-${element.id}`);

    if (pin) return;

    const el = document.createElement('img');
    el.src = '/wp-content/themes/studiometa/static/svg/pin-orange-bordered.svg';
    el.className = 'absolute pop pop-in';
    el.id = `pin-${element.id}`;
    el.style.width = `19px`;
    el.style.height = `24px`;
    el.style.alt = '';
    el.style.left = `${element.dataset.x}px`;
    el.style.top = `${element.dataset.y}px`;
    this.$refs.containerMap.append(el);
  }

  /**
   * Remove pin for unselected checkbox
   * @param  {object} element
   * @returns {void}
   */
  removePin(element) {
    const pin = document.querySelector(`#pin-${element.id}`);

    if (pin) {
      pin.classList.remove('pop-in');
      pin.classList.add('pop-out');
      setTimeout(() => {
        pin.remove();
      }, 400);
    }
  }
}
